/* eslint-disable prettier/prettier */
import '../../../styles/InfoPanel.scss';
import { Button } from 'reactstrap';
import { Icon } from 'react-icons-kit';
import { download, x } from 'react-icons-kit/feather';
import ReactModal from 'react-modal';
const Modal = ReactModal as any;
import PartnersDetails from './PartnersDetails';
import PerfectScrollbar from 'react-perfect-scrollbar';
import React, { useState } from 'react';

const PartnersDetailsComponent = PartnersDetails as React.ComponentType;

const modalStyle = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    width: '80%',
    maxWidth: '1500px',
    transform: 'translate(-50%, -50%)',
  },
};

import checkListPDF from '../../../resourceDocuments/Check_List_Viatura__English.pdf';
import priceModel from '../../../resourceDocuments/pricemodel.xlsx';
import slaPDF from '../../../resourceDocuments/AGE SLA_June_2026.pdf';
import userManualPDF from '../../../resourceDocuments/AGE_International_Platform_Manual_V2.pdf';

const tabs = [
  { id: '1', label: 'Pricing\nInformation' },
  { id: '2', label: 'Member\nInformation' },
  { id: '3', label: 'Documents' },
];

const InfoPanel: React.FC<InfoPanelProps> = ({ isOpen, toggle, initialTab }) => {
  const [currentActiveTab, setCurrentActiveTab] = useState(initialTab || '1');

  React.useEffect(() => {
    if (isOpen && initialTab) {
      setCurrentActiveTab(initialTab);
    }
  }, [isOpen, initialTab]);

  const _toggle = (tab: string) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  };

  return (
    <Modal isOpen={isOpen} style={modalStyle} ariaHideApp={false} contentLabel="Resources">
      <PerfectScrollbar className="info-panel-container">
        <div className="resources-modal-body">
          {/* Header */}
          <div className="resources-header">
            <h2 className="resources-title">Resources</h2>
            <div className="resources-title-underline" />
          </div>

          {/* Stepper tabs */}
          <div className="resources-stepper">
            {tabs.map((tab, idx) => (
              <React.Fragment key={tab.id}>
                <div
                  className={`stepper-item${currentActiveTab === tab.id ? ' active' : ''}`}
                  onClick={() => _toggle(tab.id)}
                >
                  <div className="stepper-circle">
                    <span>{idx + 1}</span>
                  </div>
                  <div className="stepper-label">
                    {tab.label.split('\n').map((line, i) => (
                      <span key={i}>{line}<br /></span>
                    ))}
                  </div>
                </div>
                {idx < tabs.length - 1 && <div className={`stepper-line${parseInt(currentActiveTab) > idx + 1 ? ' done' : ''}`} />}
              </React.Fragment>
            ))}
          </div>

          {/* Tab 1: Pricing Information */}
          {currentActiveTab === '1' && (
            <div className="resources-tab-content">
              <div className="pricing-section">
                {/* Section header */}
                <div className="section-banner teal">
                  <div>
                    <div className="section-banner-title">International Jobs Pricing</div>
                    <div className="section-banner-subtitle">Last Reviewed 1st January 2026</div>
                  </div>
                  <a href={priceModel} download="pricemodel.xlsx" className="section-download-btn">
                    <Icon icon={download} size={20} />
                  </a>
                </div>

                {/* Fitting prices table */}
                <div className="pricing-card">
                  <table className="price-table price-table--four-col">
                    <colgroup>
                      <col className="label-col" />
                      <col className="value-col" />
                      <col className="value-col" />
                      <col className="value-col" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th></th>
                        <th>Windshields &amp; Rear Windows</th>
                        <th>Side Glass</th>
                        <th>Rooftop Sunroof</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="multiplier-row">
                        <td className="row-label">Purchase Price</td>
                        <td>x 1.5</td>
                        <td>x 1.5</td>
                        <td>x 1.5</td>
                      </tr>
                      <tr>
                        <td className="row-label">Fitting Price Cars</td>
                        <td>96.81 €</td>
                        <td>59.97 €</td>
                        <td>253.71 €</td>
                      </tr>
                      <tr>
                        <td className="row-label">Fitting Price Vans</td>
                        <td>108.98 €</td>
                        <td>60.55 €</td>
                        <td>253.71 €</td>
                      </tr>
                      <tr>
                        <td className="row-label">Fitting Price Trucks</td>
                        <td>181.64 €</td>
                        <td>96.86 €</td>
                        <td>253.71 €</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* Adhesive table */}
                <div className="pricing-card">
                  <table className="price-table price-table--four-col">
                    <colgroup>
                      <col className="label-col" />
                      <col className="value-col" />
                      <col className="value-col" />
                      <col className="value-col" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th></th>
                        <th></th>
                        <th>Cars/Caravans &amp; Vans</th>
                        <th>Trucks</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="row-label">Adhesive</td>
                        <td></td>
                        <td>33.6 €</td>
                        <td>73.5 €</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* Calibration table */}
                <div className="pricing-card">
                  <table className="price-table price-table--four-col">
                    <colgroup>
                      <col className="label-col" />
                      <col className="value-col" />
                      <col className="value-col" />
                      <col className="value-col" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th></th>
                        <th></th>
                        <th>Cars/Caravans &amp; Vans</th>
                        <th>Trucks</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="row-label">Static &amp; Dynamic Calibration</td>
                        <td></td>
                        <td>132.3 €</td>
                        <td>198.45 €</td>
                      </tr>
                      <tr>
                        <td className="row-label">Stereo Double Camera &amp; Static Calibration</td>
                        <td></td>
                        <td>220.5 €</td>
                        <td>n/a</td>
                      </tr>
                      <tr>
                        <td className="row-label">Remote Calibration</td>
                        <td></td>
                        <td>136.5 €</td>
                        <td>n/a</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Delivering from Car Dealers */}
              <div className="pricing-section">
                <div className="section-banner blue">
                  <div className="section-banner-title">Delivering from Car Dealers</div>
                </div>

                <div className="pricing-card">
                  <table className="price-table price-table--four-col">
                    <colgroup>
                      <col className="label-col" />
                      <col className="value-col" />
                      <col className="value-col" />
                      <col className="value-col" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th></th>
                        <th>Windshields &amp; Rear Windows</th>
                        <th>Side Glass</th>
                        <th>Rooftop Sunroof</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="multiplier-row">
                        <td className="row-label">Purchase Price</td>
                        <td>x 1.2</td>
                        <td>x 1.2</td>
                        <td>n/a</td>
                      </tr>
                      <tr>
                        <td className="row-label">Fitting Price Cars</td>
                        <td>96.86 €</td>
                        <td>60.55 €</td>
                        <td>n/a</td>
                      </tr>
                      <tr>
                        <td className="row-label">Fitting Price Vans</td>
                        <td>108.98 €</td>
                        <td>60.55 €</td>
                        <td>n/a</td>
                      </tr>
                      <tr>
                        <td className="row-label">Fitting Price Trucks</td>
                        <td>181.64 €</td>
                        <td>96.86 €</td>
                        <td>n/a</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="pricing-card">
                  <table className="price-table price-table--four-col">
                    <colgroup>
                      <col className="label-col" />
                      <col className="value-col" />
                      <col className="value-col" />
                      <col className="value-col" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th></th>
                        <th></th>
                        <th>Cars/Caravans &amp; Vans</th>
                        <th>Trucks</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="row-label">Adhesive</td>
                        <td></td>
                        <td>33.6 €</td>
                        <td>73.5 €</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="pricing-card">
                  <table className="price-table price-table--four-col">
                    <colgroup>
                      <col className="label-col" />
                      <col className="value-col" />
                      <col className="value-col" />
                      <col className="value-col" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th></th>
                        <th></th>
                        <th>Cars/Caravans &amp; Vans</th>
                        <th>Trucks</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="row-label">Static &amp; Dynamic Calibration</td>
                        <td></td>
                        <td>132.3 €</td>
                        <td>198.45 €</td>
                      </tr>
                      <tr>
                        <td className="row-label">Stereo Double Camera &amp; Static Calibration</td>
                        <td></td>
                        <td>220.5 €</td>
                        <td>n/a</td>
                      </tr>
                      <tr>
                        <td className="row-label">Remote Calibration</td>
                        <td></td>
                        <td>136.5 €</td>
                        <td>n/a</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Other Services */}
              <div className="pricing-section">
                <div className="section-banner slate">
                  <div className="section-banner-title">Other Services</div>
                </div>
                <div className="pricing-card">
                  <table className="price-table">
                    <tbody>
                      <tr>
                        <td className="row-label">Windshield Repair</td>
                        <td>66.60 €</td>
                        <td className="row-note">Max 2 Repairs</td>
                      </tr>
                      <tr>
                        <td className="row-label">Mobile Service</td>
                        <td>30.27 €</td>
                        <td className="row-note">(30km from the nearest branch)</td>
                      </tr>
                      <tr>
                        <td className="row-label">Emergency Glass (Plexiglass)</td>
                        <td>38.85 €</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td className="row-label">After Hours</td>
                        <td>97.65 €</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Additional Rules */}
              <div className="pricing-section">
                <div className="section-banner slate">
                  <div className="section-banner-title">Additional Rules</div>
                </div>
                <div className="pricing-card">
                  <ol className="rules-list">
                    <li>Eurocodes or similar references must be included on the invoice.</li>
                    <li>Calibration reports/proof must be uploaded to the platform; otherwise, no payment will be executed for this service.</li>
                    <li>If the glass is purchased by the dealer, the invoice must also be uploaded to the platform (noted in the relevant section when available).</li>
                    <li>The invoice must include the excess information paid by the customer.</li>
                    <li>The invoice is with 0% Taxes always.</li>
                    <li>For all the services performed in Switzerland, local VAT must now be charged as required by Swiss tax authorities.</li>
                  </ol>
                  <br/>
                  <p className='notes-text'><b>Note:</b> DESA AUTOGLASS is the only member that doesn’t apply this pricing list. So in their case, they apply local prices with attention to AGE colleagues; please do the same.
                  123Pare Brise is applying their local prices with 200€ discount. Members should apply the same.</p>
                </div>
              </div>
            </div>
          )}

          {/* Tab 2: Member Information */}
          {currentActiveTab === '2' && (
            <div className="resources-tab-content">
              <PartnersDetailsComponent />
            </div>
          )}

          {/* Tab 3: Documents */}
          {currentActiveTab === '3' && (
            <div className="resources-tab-content">
              <div className="pricing-section">
                <div className="section-banner teal">
                  <div className="section-banner-title">Documents</div>
                </div>
                <div className="pricing-card documents-grid-wrapper">
                  <div className="documents-grid">
                    <a href={checkListPDF} download="Check_List_Viatura__English.pdf" className="document-card">
                      <span className="document-card-label">Checklist</span>
                      <Icon icon={download} size={22} />
                    </a>
                    <a href={slaPDF} download="AGE SLA_June_2026.pdf" className="document-card">
                      <span className="document-card-label">SLA</span>
                      <Icon icon={download} size={22} />
                    </a>
                    <a href={userManualPDF} download="AGE_International_Platform_Manual_V2.pdf" className="document-card">
                      <span className="document-card-label">Manual</span>
                      <Icon icon={download} size={22} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </PerfectScrollbar>
      <Button className="modal-close-btn" onClick={() => toggle()}>
        <Icon icon={x} size={48} />
      </Button>
    </Modal>
  );
};

export default InfoPanel;
